<template>
    <div class="couponProfile">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1">&nbsp;</div>
                <div class="searchBox">
                    <div class="back">
                        <button class="back-arrow" @click="$router.push({name:'addcoupon'})">返回</button>
                    </div>
                    <div class="coupon-info">
                        <div class="couopon-name info-item">优惠券名称：{{$route.query.couponName}}</div>
                        <div class="create-name info-item">创建人：{{$route.query.createName}}</div>
                        <div class="couopon-desc info-item" style="padding-top:10px">
                            <div>
                                <span class="time" v-if="$route.query.startTime && $route.query.endTime && !$route.query.expireDay">有效时间：<i>{{$route.query.startTime | numberToDate('')}}</i>至<i>{{$route.query.endTime | numberToDate('')}}</i></span>
                                <span class="time" v-else>有效天数：<i>{{$route.query.expireDay}}天</i></span>
                                <span class="gift"> 已派发：{{$route.query.sendCount}}张</span>
                                <span class="gift"> 已使用：{{$route.query.useCount}}张</span>
                            </div>
                            <div class="stop">
                                <button v-if="$route.query.statusType!='STOP'&&$route.query.statusType!='EXPIRED'" @click="stop">停用</button>
                            </div>
                        </div>
                    </div>
                    <div class="tab-change">
                        <span @click="filterCoupon('NORMAL')" :class="{active:filterStatus=='NORMAL'}" class="tab-item">已派发优惠券</span>
                        <span @click="filterCoupon('STOP')" :class="{active:filterStatus=='STOP'}" class="tab-item">已作废优惠券</span>
                    </div>
                    <div class="coupon-filter">
                        <div class="search-wrap">
                            <span>会员搜索：</span>
                            <!-- <el-input style="width:200px" placeholder=""></el-input> -->
                            <div class="search" style="width:200px;">
                                <el-input type="text" style="padding-left:5px;" v-model="searchPhone" placeholder="请输入会员手机号码." />
                                <!-- <button>查询</button> -->
                                <div class="vip-list-wrap" v-if="searchData.length>0">
                                    <div class="vip-list">
                                        <ul>
                                            <li @click="setNowSearchVip(item)" v-for="(item,index) in searchData" :key="index" @mouseenter="nowVipIndex=index" :class="nowVipIndex==index?'active':''">
                                                <span class="name">{{item.name}}</span>
                                                <span class="phone-num right">{{item.mobile}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:15%">抵用商品名称</th>
                                <th style="width:12%">会员名称</th>
                                <th style="width:10%">会员号码</th>
                                <th style="width:10%">派发员工</th>
                                <th style="width:10%">派发时间</th>
                                <th style="width:15%">到期时间</th>
                                <th style="width:10%">状态</th>
                                <th style="width:10%">核销时间</th>
                                <th style="width:8%">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:couponList.length>pageSize}">
                                    <tr v-for="(item,ind) in couponList" class="listTr">
                                        <td style="width:15%" class="wrap">
                                            <el-tooltip effect="dark" :key="item.id" :disabled="!item.id" :content="$route.query.goodsName" placement="top">
                                                <span class="overflowText" v-if="item.id">{{$route.query.goodsName}}</span>
                                            </el-tooltip>
                                        </td>
                                        <td style="width:12%">{{item.memberName}}</td>
                                        <td style="width:10%">{{item.mobile}}</td>
                                        <td style="width:10%">{{item.creatorName}}</td>
                                        <td style="width:10%">{{item.addTime | numberToDate('')}}</td>
                                        <td style="width:15%">
                                            <template v-if="item.id">
                                                <span>{{item.endTime | dateForGradePage}}</span>
                                            </template>
                                            <!-- <template v-if="item.id">
                                                <span v-if="item.id && !$route.query.expireDay"><i>{{item.beginTime | numberToDate('')}}</i>至<i>{{item.endTime | numberToDate('')}}</i></span>
                                                <span v-else>{{computedTime(item)}}</span> 
                                            </template> -->
                                        </td>
                                        <td style="width:10%">{{stautsOprions[item.stauts]}}</td>
                                        <td style="width:10%">
                                            <span v-if="item.id">{{item.stauts=="VERIFIED"?new Date(item.validateTime).Format("yyyy/MM/dd hh:mm:ss"):"--"}}</span> 
                                        </td>
                                        <td style="width:8%">
                                            <span @click="stopItem(item)" v-if="item.id&&item.stauts=='NORMAL'" style="color:red;cursor:pointer">作废</span>
                                            <span v-if="item.id&&item.stauts!='NORMAL'">---</span>
                                        </td>
                                    </tr>
                                </table>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="pagination">
                    <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="totalElements">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import {API_BASE_URL} from "./../../../urlConfig/index";
    export default{
        props: ['curStoreId'],
        data () {
            return {
                filterStatus:"NORMAL",
                pageSize:9,
                stautsOprions:{
                    NORMAL:"未使用",
                    STOP:"已作废",
                    EXPIRED:"已过期",
                    VERIFIED:"已核销",
                },
                nowSelVip:null,
                nowVipIndex:0,
                searchData:[],
                searchPhone:"",
                nowSelFilter:"today",
                couponList: [],
                nowType:"TIME_RANGE",
                startTime:'',//按时间段查询的起始时间
                endTime:'',//按时间段查询的结束时间
                pickerOptions: {
                    disabledDate(time) {
                    return time.getTime() > Date.now();
                    }
                },
                dateStr: new Date().Format("yyyy-MM-dd"),
                currentPage: 1,
                totalElements: 0, //数据总条数
                canClick:true,
            }
        },
        watch: {
            dateStr(val) {
                console.log(new Date(val).Format("yyyy-MM-dd"));
                let nowDate = new Date(val).Format("yyyy-MM-dd");
                this.dateStr = nowDate;
                this.getCouponDetail(0, nowDate);
            },
            searchPhone(val){
                if(!val){
                    this.nowSelVip = null;
                    this.searchData = [];
                    this.getCouponDetail();
                    // this.getVipData("AMOUNT","DOWN");
                    return;
                }
                this.searchVip();
            },
            nowSelVip(val){
                if(!val){
                    return;
                }
                this.getCouponDetail();
            }
        },
        methods: {
            computedTime(item){
                if(item.id && item.addTime){
                    let daysTimes = (this.$route.query.expireDay - 1) * 1000 * 60 * 60 * 24;
                    return new Date(new Date(new Date(item.addTime).Format("yyyy/MM/dd 00:00:00")).getTime() + daysTimes ).Format("yyyy-MM-dd 23:59:59")                  
                }
            },
            // 
            stop(){
                this.$confirm('确认停用该优惠券吗？停用后该优惠券将整体作废，不能继续派发！', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    this.$http({
                    url:"/stop/coupon",
                    method:"GET",
                    params:{
                       id: this.$route.query.id
                    }
                }).then(res=>{
                    this.getCouponDetail();
                    this.$router.push({
                        name:"addcoupon",
                        query:{
                            type:"STOP"
                        }
                    })
                });
                })
            },
            filterCoupon(type){
                this.filterStatus = type;
                this.currentPage=1;
                this.getCouponDetail();
            },
            stopItem(item){
                this.$confirm('确认操作?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    this.$http({
                    url:"/stop/member/coupon",
                    method:"GET",
                    params:{
                       id: item.id
                    }
                }).then(res=>{
                    this.getCouponDetail();
                });
                })
            },
            searchVip(){
                this.$http({
                    url:API_BASE_URL+"v1/pos/members",
                    method:"GET",
                    params:{
                       storeId: this.curStoreId,
                       q: this.searchPhone
                    }
                }).then(res=>{
                    this.searchData = res.data;
                });
            },
            //分页方法
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.getCouponDetail();
            },
            setNowSearchVip(item){
                this.nowSelVip = item;
                this.searchData = [];
            },
            filter(type){
                let timeRangeArr = [];
                this.nowSelFilter = type;
                switch (type) {
                    case "today":
                        // this.yearMonth = new Date().Format("yyyy-MM");
                        this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
                        // let year = new Date().Format("yyyy");
                        // let month = new Date().Format("MM");
                        this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "lastDay":
                        this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
                        this.startTime = `${new Date(new Date(this.startTime).getTime() - 1000*60*60*24).Format("yyyy/MM/dd")} 00:00:00`;
                        this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
                        this.endTime = `${new Date(new Date(this.endTime).getTime() - 1000*60*60*24).Format("yyyy/MM/dd")} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "week":
                        timeRangeArr = this.$dateRange.getThisWeek();
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "lastWeek":
                        timeRangeArr = this.$dateRange.getLastWeek();
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "month":
                        timeRangeArr = this.$dateRange.getThisMonth();
                        console.log(timeRangeArr)
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "lastMonth":
                        timeRangeArr = this.$dateRange.getLastMonth();
                        console.log(timeRangeArr)
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    default:
                        break;
                }
            },
             // 搜索
            searchConfirm: function () {
                // 
                let timeStr = new Date(this.startTime).getTime() + "-" + new Date(this.endTime).getTime();
                let nowTime = new Date().getTime();
                if(!(this.$canClickSelect("couponDetailTimeRange",timeStr,nowTime))){
                    this.$message({
                        message: '5秒内禁止重复查询相同数据',
                        customClass: 'error'
                    });
                    return;
                }
                // 
                if(((new Date(this.endTime)).getTime() - (new Date(this.startTime)).getTime()) > 1000*60*60*24*35){
                    this.$message({
                        message: '只能查询35天内的数据',
                        customClass: 'error'
                    })
                    return;
                }
                if(this.startTime!=='' && this.endTime!==''){
                    if(new Date(this.startTime)>new Date(this.endTime)){
                        this.$message({
                            message: '结束时间不能比开始时间小',
                            customClass: 'error'
                        })
                        return;
                    }
                    if(this.canClick){
                        this.canClick = false;
                        this.getCouponDetail(0, this.dateStr,"ARB");
                    }
                }else{
                    this.$message({
                        message: '请选择查询时间段',
                        customClass: 'error'
                    })
                    return;
                }
            },
            getCouponDetail: function (page=0, date, type="DAY") {

                let params;
                
                params = {
                    memberId:this.nowSelVip?this.nowSelVip.id:"",
                    couponId:this.$route.query.id,
                    status:this.filterStatus,
                    page:this.currentPage - 1,
                    size: this.pageSize,
                }

                this.$http({
                    url:"/coupon/detail",
                    method:"GET",
                    params
                }).then((res)=>{
                    setTimeout(()=>{
                        this.canClick = true;
                    },500);
                    let body = res.data;
                    console.log(res)
                    this.couponList = body.data;
                    this.totalElements = body.totalElements;
                    let number = this.pageSize - this.couponList.length;
                    if ( number > 0 ) {
                        for (let i = 0; i < number; i++) {
                            this.couponList.push({});
                        }
                    }
                }).catch((err)=>{
                    setTimeout(()=>{
                        this.canClick = true;
                    },500);
                })
            },
        },
        activated: function () {
            for (let i = 0; i < this.pageSize; i++) {
                this.couponList.push({
                    id: '', // 员工id
                    name: '', // 员工姓名
                    code: '', // 编号
                    mobile: '', // 手机
                    groupName: '' // 岗位id
                })
            }
            this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
            let year = new Date().Format("yyyy");
            let month = new Date().Format("MM");
            this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
            // 获取员工列表
            this.filterStatus="NORMAL";
            this.getCouponDetail(0,this.dateStr,"ARB");
        },
        mounted: function () {
            // 改变关闭样式
            $(document).ready(()=>{
                $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            });
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
    @import "couponProfile.scss";
    .el-tooltip__popper{
        max-width: 300px;
        max-height: 350px;
        overflow: hidden;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// couponProfile.vue?60d95def